const CHARGING_STATUSES = ["active", "past_due", "overdue"];

/**
 * What a vendor needs to know about the sales promo running on their membership
 * (the website API's `discount` on the billing status), or null when there is none.
 * `nextPayment` is an approximate next payment while discounted payments remain; the
 * recurring amount is VAT-inclusive.
 */
export function membershipPromo(billingStatus) {
  const discount = billingStatus?.discount;
  if (!discount?.code) return null;

  const percentOff = Number(discount.percent_off);
  const remaining = Math.max(0, Number(discount.remaining_cycles ?? 0));
  const finished = discount.status === "COMPLETED" || remaining === 0;
  const amount = billingStatus?.amount;
  // Only a membership that will be charged again has a next payment (not cancelling or cancelled).
  const charging = CHARGING_STATUSES.includes(String(billingStatus?.status || "").toLowerCase());
  const nextPayment =
    !finished && charging && amount != null && Number.isFinite(Number(amount))
      ? Math.round(((Number(amount) * (100 - percentOff)) / 100 + Number.EPSILON) * 100) / 100
      : null;

  return {
    code: discount.code,
    percentOff,
    used: Number(discount.cycles_applied ?? 0),
    total: Number(discount.duration_cycles ?? 0),
    remaining,
    finished,
    nextPayment,
  };
}
